export const getProfessorRecordText = rec => {
  let text = rec.scientificDegreeNameBg || "";
  if (rec.firstName) {
    text += ` ${rec.firstName}`;
  }
  if (rec.secondName) {
    text += ` ${rec.secondName}`;
  }
  if (rec.lastName) {
    text += ` ${rec.lastName}`;
  }
  return text.trim() || "-";
};
